import { render, staticRenderFns } from "./LocationTariffsListTable.vue?vue&type=template&id=75791b75&scoped=true&"
import script from "./LocationTariffsListTable.vue?vue&type=script&lang=js&"
export * from "./LocationTariffsListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75791b75",
  null
  
)

export default component.exports